export interface LocaleOptions {
  languageCodeOnly?: boolean;
}

const getLocales = (options: LocaleOptions = {}): string[] => {
  const defaultOptions = {
    languageCodeOnly: false,
  };

  const opt = {
    ...defaultOptions,
    ...options,
  };

  let browserLocales = ['en-us'];

  if (typeof navigator !== 'undefined') {
    if (navigator.language) {
      browserLocales = [navigator.language];
    }

    if (navigator.languages) {
      browserLocales = [...navigator.languages];
    }
  }

  return browserLocales.map((locale) => {
    const trimmedLocale = locale.trim();
    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
  });
};

export const getLocale = (options?: LocaleOptions): string => {
  return getLocales(options)[0] || 'en-us';
};
